// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"8a6a3203","161":"25e00b20","209":"e1f55257","478":"3552972d","625":"4eb24531","745":"dd1a250d","922":"9c7b09da","964":"9d05c99e"}[chunkId] + ".chunk.js";
};